import React from 'react';

import HistoryIcon from '@material-ui/icons/History';

export default function DocumentHistoryButton(props)
{
  return {
      color : "inherit",
      label : "改定履歴",
      "aria-label" : "この帳票の改定履歴を開く",
      icon : <HistoryIcon />,
      ...props
  }
}